var render = function render(){var _vm=this,_c=_vm._self._c;return _c('branch-chart',{attrs:{"styles":_vm.ChartStyle}})
}
var staticRenderFns = []

export { render, staticRenderFns }